import fetch, { parseListResponse, parseResponse } from "./fetch";

export interface SecteurInterface {
    secteur_id: number;
    name: string;
}

class Secteur {
    all(params?: HashMap<any>) {
        return parseListResponse<SecteurInterface>(fetch.get(`secteurs/liste/`, { params }));
    }

    one(id: string) {
        return parseResponse<SecteurInterface>(fetch.get(`secteurs/${id}`));
    }
}

export default new Secteur();
